import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

export default class extends Controller {
  connect() {
    this.mask = IMask(this.element, {
      mask: "000.000.000-00",
    });
  }

  disconnect() {
    if (this.mask) this.mask.destroy();
  }
}
